module.exports = __webpack_public_path__ + "static/media/EditEvent.6a704352.svg";